export enum UserTypes {
  customer = 'customer',
  host = 'host',
  superAdmin = 'superAdmin',
  manager = 'manager'
}
